import React from 'react'
import pic from '../assets/pic.jpeg'

const About = ({ lightMode }) => {
    return (
        <div className={'section ' + (lightMode ? 'light-primary' : 'dark-primary')}>
            <p className="norm-header">About</p>
            <div className="about-content">
                <div className="about-img">
                    <img src={pic} alt="" />
                </div>
                <p className="bio">
                    Hi! I'm Aka and I'm a full-stack MERN and Web3 developer from Nigeria and the founder of <span>BLUEJAG</span><br />
                    <br />
                    I hold a B.Eng degree in Electronic and Computer Engineering. I started my journey in programming a year before I got into the university and although it influenced my decision on the course I majored, everything I know about programming, I learnt online.<br />
                    <br />
                    After graduating, I began freelancing as a developer, creating video content for twitter page and websites for small businesses using React, Node, Solidity and so many other frameworks.<br />
                    <br />
                    In recent years, I've been focused on building a strong portfolio, growing this brand (BlueJag) by putting together a solid team of developers, learning skills to enable me build top-notch, grade-A websites and creating exciting projects that solve real-world problems.<br />
                    <br />
                    Take a look at my work below to see what I'm working on, and get in touch if you'd like to work together! <br />
                </p>
            </div>
        </div>
    )
}

export default About
